import React from 'react';

/**
 * Standard page heading.
 *   <PageHeader title="Pages" subtitle="Search every page" actions={<button className="btn btn-primary">New</button>} />
 */
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="page-header">
      <div>
        <h1>{title}</h1>
        {subtitle && <p className="subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="actions">{actions}</div>}
    </div>
  );
}
